export enum TiposMutationSnackbar {
    SET_COLOR = 'setColor',
    SET_SHOW = 'setShow',
    SET_TIME = 'setTime',
    SET_MENSAGEM = 'setMensagem'
}
